/**
 * Semáforo de vigencia de certificados (FIEL / CSD).
 * none=negro, ok=verde, warning=amarillo, danger=rojo
 */


import { CERT_INDICADOR_COLORS, CERT_INDICADOR_LABELS } from '../../constants/certIndicador'

export function CertIndicadorDot({ indicador, title, size = 10 }) {
  const key = CERT_INDICADOR_COLORS[indicador] ? indicador : 'none'
  const label = title || CERT_INDICADOR_LABELS[key]
  return (
    <span
      title={label}
      aria-label={label}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: CERT_INDICADOR_COLORS[key],
        border: key === 'none' ? '1px solid #666' : 'none',
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    />
  )
}
